import slider1 from '../Food-image/slider1.jpeg'
import slider2 from '../Food-image/slider2.avif'
import slider3 from '../Food-image/slider3.jpg'

export const imageSlider = [
  {
    img: slider1,
    title: "أشهى برجر مشوي",
    description: "طعمه لا يُقاوم، جربه واستمتع بنكهات مميزة!"
  },
  {
    img: slider2,
    title: "بيتزا إيطالية أصلية",
    description: "جبنة سايحة وعجينة مقرمشة.. مستحيل تقاومها!"
  },
  {
    img: slider3,
    title: "حلويات لذيذة",
    description: "ختامها مسك.. حلويات ترضي كل الأذواق."
  }
]
